import React from 'react';
import './index.css';
import image from './avatar.jpg';
import Tobaedd from './Images-to-be-added-soon.jpg';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { FaMapMarkerAlt, FaEnvelope, FaPhone, FaLinkedin } from 'react-icons/fa';

const AboutUsPage = () => {
    const teamMembers = [
        {
            name: 'Li xiaohong',
            position: 'Founder',
            phone: '94551268',
            image: image
        },
        {
            name: 'Cao Zhang Lin',
            position: 'Site Manager',
            phone: '97966058',
            image: image
        },
        {
            name: 'Wang Jun Ya',
            position: 'Office Manager',
            phone: '88094816',
            image: image
        },
        {
            name: 'Li Jian',
            position: 'IT Manager',
            phone: '94870716',
            image: image
        }
    ];

    const contactInfo = [
        {
            icon: <FaMapMarkerAlt size={24} />,
            title: 'Location',
            content: ['2 Yishun Industrial Street 1', '#03-25 Northpoint Bizhub', 'Singapore 768159']
        },
        {
            icon: <FaEnvelope size={24} />,
            title: 'Email',
            content: ['hongyuansg@hotmail.com']
        },
        {
            icon: <FaPhone size={24} />,
            title: 'Call',
            content: ['+65 62626341', '+65 94551268']
        }
    ];

    return (
        <>
            {/* Hero Map Section */}
            <div className="map-container">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15954.263400566693!2d103.83455523297617!3d1.435674983247176!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da1460eac7ad97%3A0xe7353622d4e32e26!2sSingapore%20768159!5e0!3m2!1sen!2ssg!4v1629792923002!5m2!1sen!2ssg"
                    className="w-100"
                    style={{ height: '400px', border: 0 }}
                    allowFullScreen
                    loading="lazy"
                />
            </div>

            {/* Contact Information Section */}
            <Container className="contact-section py-5">
                <Row className="justify-content-center g-4">
                    {contactInfo.map((info, index) => (
                        <Col key={index} lg={4} md={6}>
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: index * 0.1 }}
                                className="contact-card"
                            >
                                <Card className="border-0 shadow-sm h-100 text-center p-4">
                                    <div className="icon-circle mb-3 mx-auto">
                                        {info.icon}
                                    </div>
                                    <h4 className="mb-3">{info.title}</h4>
                                    {info.content.map((line, i) => (
                                        <p key={i} className="mb-1 text-muted">{line}</p>
                                    ))}
                                </Card>
                            </motion.div>
                        </Col>
                    ))}
                </Row>
            </Container>

            {/* Team Section */}
            <section className="team-section py-5 bg-light">
                <Container>
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        className="text-center mb-5"
                    >
                        <h2 className="display-5 fw-bold text-primary mb-3">Our Team</h2>
                        <p className="lead text-muted">Meet the people behind Hong Yuan Construction</p>
                    </motion.div>

                    <Row className="g-4">
                        {teamMembers.map((member, index) => (
                            <Col key={index} xl={3} sm={6}>
                                <motion.div
                                    initial={{ opacity: 0, y: 20 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.5, delay: index * 0.1 }}
                                >
                                    <Card className="team-card border-0 shadow-sm h-100">
                                        <div className="text-center p-4">
                                            <div className="member-image-wrapper mb-4">
                                                <img
                                                    src={member.image}
                                                    alt={member.name}
                                                    className="rounded-circle img-thumbnail shadow-sm"
                                                    width="120"
                                                />
                                            </div>
                                            <h5 className="mb-2">{member.name}</h5>
                                            <span className="text-muted d-block mb-3">{member.position}</span>
                                            <div className="contact-info">
                                                <FaPhone className="me-2" />
                                                <span>{member.phone}</span>
                                            </div>
                                        </div>
                                    </Card>
                                </motion.div>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>

            {/* Community Feedback Section */}
            <section className="feedback-section py-5">
                <Container>
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        className="text-center mb-5"
                    >
                        <h2 className="display-5 fw-bold text-primary mb-3">Community Feedback</h2>
                        <p className="lead text-muted">Our contribution to the community</p>
                    </motion.div>

                    <Row className="g-4">
                        {[...Array(6)].map((_, index) => (
                            <Col key={index} lg={4} md={6}>
                                <motion.div
                                    initial={{ opacity: 0, y: 20 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.5, delay: index * 0.1 }}
                                >
                                    <Card className="gallery-card border-0 shadow-sm overflow-hidden">
                                        <div className="image-hover-zoom">
                                            <Card.Img
                                                src={Tobaedd}
                                                alt="Community Feedback"
                                                className="w-100"
                                            />
                                        </div>
                                    </Card>
                                </motion.div>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>

            {/* Footer */}
            <footer className="bg-dark text-white-50 py-4 mt-5">
                <Container className="text-center">
                    <small>
                        {new Date().getFullYear()} Copyright © Hong Yuan Construction Pte Ltd, UEN:200922798D
                    </small>
                </Container>
            </footer>
        </>
    );
};

export default AboutUsPage;
